/**
 * 全站http配置
 *
 * axios参数说明
 * isSerialize是否开启form表单提交
 * isToken是否需要token
 */
import axios from "axios";
import store from "@/store/";
import router from "@/router/router";
import { serialize } from "@/util/util";
import { getToken } from "@/util/auth";
import { Message } from "element-ui";
import { isURL } from "@/util/validate";
import website from "@/config/website";
import { Base64 } from "js-base64";
import { baseUrl } from "@/config/env";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

//默认超时时间
axios.defaults.timeout = 3 * 60 * 1000;
//返回其他状态码
axios.defaults.validateStatus = function(status) {
    return status >= 200 && status <= 500;
};
const env = process.env

//跨域请求，允许保存cookie
axios.defaults.withCredentials = true;
// NProgress 配置
NProgress.configure({
    showSpinner: false,
});
//http request拦截
axios.interceptors.request.use(
        (config) => {
            //开启 progress bar
            if(!config.nprogress) NProgress.start();
            //地址为已经配置状态则不添加前缀
            if (!isURL(config.url) && !config.url.startsWith(baseUrl)) {
                config.url = baseUrl + config.url;
            }
            //headers判断是否需要
            const authorization = config.authorization === false;
            if (!authorization) {
                config.headers["Authorization"] = `Basic ${Base64.encode(
        `${website.clientId}:${website.clientSecret}`
      )}`;
    }
    //让每个请求携带token
    const meta = config.meta || {};
    const isToken = meta.isToken === false;
    if (getToken() && !isToken) {
      config.headers[website.tokenHeader] = "bearer " + getToken();
    }
    //headers中配置text请求
    if (config.text === true) {
      config.headers["Content-Type"] = "text/plain";
    }
    //headers中配置serialize为true开启序列化
    if (config.method === "post" && meta.isSerialize === true) {
      config.data = serialize(config.data);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http response 拦截
axios.interceptors.response.use(
  (res) => {
    //关闭 progress bar
    NProgress.done();
    //获取状态码
    const status = res.data.code || res.status;
    const statusWhiteList = website.statusWhiteList || [];
    const message = res.data.msg || res.data.error_description || "未知错误";
    //如果在白名单里则自行catch逻辑处理
    if (statusWhiteList.includes(status)) return Promise.reject(res);
    //如果是401则跳转到登录页面
    if (status === 401) {
      store.dispatch("FedLogOut").then(() => router.push({ path: "/login" }));
      message = "登录已过期, 请重新登陆";
    }
    // 如果请求为非200否者默认统一处理
    if (status !== 200) {
      Message({
        message: message,
        type: "error",
      });
      return Promise.reject(new Error(message));
    }
    if (status === 500) {
      Message({
        message: "服务器错误",
        type: "error",
      });
      return Promise.reject(new Error(message));
    }
    if (status === 502) {
      Message({
        message: "服务器正在发版, 如五到十分钟内还未恢复, 请联系技术人员",
        type: "error",
      });
      return Promise.reject(new Error(message));
    }
    return res;
  },
  (error) => {
    if (
      error.code == "ECONNABORTED" ||
      error.message == "Network Error" ||
      error.message.includes("timeout")
    ) {
      Message({
        message: "请求超时, 请稍后再试",
        type: "error",
      });
    }
    if (error.code == "Bad Gateway") {
      Message({
        message: "服务器正在发版, 如五到十分钟内还未恢复, 请联系技术人员",
        type: "error",
      });
    }
    NProgress.done();
    return Promise.reject(new Error(error));
  }
);

export default axios;
